export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/entitiesRefs.worker.560652e9.worker.js");
}
